import { getDomainUrl } from 'coreOld/utils';

export const systemSettingsPath = () => '/system';

//nested routes
export const usersPath = () => `${systemSettingsPath()}/users`;
export const partsPath = () => `${systemSettingsPath()}/parts`;
export const manufacturersPath = () => `${systemSettingsPath()}/manufacturers`;
export const sitesPath = () => `${systemSettingsPath()}/sites`;
export const searchPath = () => `${systemSettingsPath()}/search`;

export const oldPartsPath = () => `${getDomainUrl()}/system/parts`;
